import { render, staticRenderFns } from "./UserConsole.vue?vue&type=template&id=dd772936&"
import script from "./UserConsole.vue?vue&type=script&lang=ts&"
export * from "./UserConsole.vue?vue&type=script&lang=ts&"
import style0 from "./UserConsole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports